import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onValidateUser = () => axios.get(`${apiPaths.authenticationBase}/validate`);

const onGetAllowedSessionTypes = (currentUserEmail) =>
  axios.get(`${apiPaths.authenticationBase}/allowed-session-types`, {
    params: { email: currentUserEmail }
  });

const onLoginWithPassword = (username, password) =>
  axios.post(`${apiPaths.authenticationBase}/password`, {
    email: username,
    password
  });

const onLoginWithMicrosoft = (accessToken) =>
  axios.post(`${apiPaths.authenticationBase}/microsoft`, {
    accessToken
  });

const onRefreshMicrosoftSession = (accessToken) =>
  axios.post(`${apiPaths.authenticationBase}/microsoft-refresh`, {
    accessToken
  });

const onLogout = () => axios.delete(apiPaths.authenticationBase);

const onGetUiRights = (userId) => axios.get(`${apiPaths.usersBase}/${userId}/ui-rights`);

const onApproveTermsOfUse = (userId) => axios.patch(`${apiPaths.usersBase}/${userId}/terms-of-use/approve`);

const onLoadUserIntercomHmac = (userId) => axios.get(`${apiPaths.usersBase}/${userId}/intercom-hmac`);

export {
  onValidateUser,
  onLoginWithPassword,
  onLogout,
  onGetUiRights,
  onGetAllowedSessionTypes,
  onApproveTermsOfUse,
  onLoadUserIntercomHmac,
  onLoginWithMicrosoft,
  onRefreshMicrosoftSession
};
